import { fetchOembed } from './fetch-oembed';
import { setTextEditorEntityData } from './set-text-editor-entity-data';
import { buildUrl } from '../services/video-embed';

export const updateTextEditorVideoEmbed = ({ identifier, entityKey, ...entityData }) => dispatch => {
  dispatch(
    setTextEditorEntityData({
      identifier,
      entityKey,
      entityData: {
        oembed: null,
        isLoading: true,
        ...entityData,
      },
    })
  );

  const publicUrl = buildUrl(entityData.url);
  return dispatch(fetchOembed(publicUrl)).then(oembed =>
    dispatch(
      setTextEditorEntityData({
        identifier,
        entityKey,
        entityData: {
          oembed,
          isLoading: false,
        },
      })
    )
  );
};



// WEBPACK FOOTER //
// ./app/actions/update-text-editor-video-embed.js